import i from "react";
var y = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, f = i.createContext && /* @__PURE__ */ i.createContext(y), g = ["attr", "size", "title"];
function d(e, r) {
  if (e == null) return {};
  var t, n, o = O(e, r);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) t = a[n], r.indexOf(t) === -1 && {}.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function O(e, r) {
  if (e == null) return {};
  var t = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (r.indexOf(n) !== -1) continue;
    t[n] = e[n];
  }
  return t;
}
function u() {
  return u = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, u.apply(null, arguments);
}
function m(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function c(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? m(Object(t), !0).forEach(function(n) {
      p(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : m(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function p(e, r, t) {
  return (r = j(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function j(e) {
  var r = P(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function P(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function b(e) {
  return e && e.map((r, t) => /* @__PURE__ */ i.createElement(r.tag, c({
    key: t
  }, r.attr), b(r.child)));
}
function x(e) {
  return (r) => /* @__PURE__ */ i.createElement(h, u({
    attr: c({}, e.attr)
  }, r), b(e.child));
}
function h(e) {
  var r = (t) => {
    var n = e.attr, o = e.size, a = e.title, v = d(e, g), s = o || t.size || "1em", l;
    return t.className && (l = t.className), e.className && (l = (l ? l + " " : "") + e.className), /* @__PURE__ */ i.createElement("svg", u({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, t.attr, n, v, {
      className: l,
      style: c(c({
        color: e.color || t.color
      }, t.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), a && /* @__PURE__ */ i.createElement("title", null, a), e.children);
  };
  return f !== void 0 ? /* @__PURE__ */ i.createElement(f.Consumer, null, (t) => r(t)) : r(y);
}
export {
  x as G
};
